import { Component, OnInit } from '@angular/core';
import { GalleryService } from 'ng-gallery';
import { HttpClient } from '@angular/common/http';

declare var jQuery: any;

@Component({
  template: require('./gallery.component.html'),
  styles: [require('./gallery.component.scss')],
})
export class GalleryComponent implements OnInit {

  private images: any = [];
  private menuStatus = true;

  constructor(private http: HttpClient, private gallery: GalleryService) { }

  ngOnInit() {
    this.http.get('./gallery.json').subscribe(data => {
      this.images = data;
      this.gallery.load(this.images);
    });
  }

  hideMenu() {
    jQuery('.headroom').removeClass('slideDown').addClass('slideUp');
  }
  showMenu() {
    jQuery('.headroom').removeClass('slideUp').addClass('slideDown');
  }

  toggleMenu() {
    if (this.menuStatus) {
        this.hideMenu();
        this.menuStatus = false;
    } else {
      this.showMenu();
      this.menuStatus = true;
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Gallery.component.ts